<template>
  <div
    class="modal fade"
    id="exampleModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Xác nhận chuyển E Voucher</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form>
            <div class="form-group">
              <label for="recipient-name" class="col-form-label"
                >Email:</label
              >
              <input required="" type="text" class="form-control" id="recipient-name" v-model="email" />
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">
            Huỷ
          </button>
          <button type="button" class="btn btn-primary" @click="onConfirm">Xác nhận</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import { mapActions } from 'vuex';
import VoucherTransactionType from 'Enum/voucherTransactionType'
export default {
  data: () => ({
    email: null,
    voucherId: null
  }),
  methods: {
    /**
     * Confirm
     */
    onConfirm: function () {
      this.$swal
        .fire({
          title: "Xác nhận chuyển E Voucher?",
          text: `Bạn có chắc muốn chuyển E Voucher này?`,
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#66bb6a",
          cancelButtonColor: "#d33",
          confirmButtonText: "Đồng ý",
          cancelButtonText: "Huỷ",
        })
        .then((result) => {
          if (result.value) {
            let filter = {
              type: VoucherTransactionType.SINGLE,
              voucherId: this.voucherId,
              email: this.email,
            };
            this.TRANSACTION_FROM_CUSTOMER_TO_CUSTOMER(filter).then(
              function() {
                this.$swal.fire(
                  "Đã xác nhận!",
                  "E Voucher của bạn đã được chuyển thành công.",
                  "success"
                );
                this.voucherId = null
                $("#exampleModal").modal('hide')
              }.bind(this)
            );
          }
        });
    },
    /**
     * Show modal
     */
    onShowModal: function(eVoucher) {
      this.voucherId = eVoucher.id
      $("#exampleModal").modal('show')
    },
    ...mapActions(['TRANSACTION_FROM_CUSTOMER_TO_CUSTOMER'])
  },
};
</script>

<style></style>
